import Typography from "./Typography.vue"
export default Typography